import { postGiftCard, redirectToPayment } from '../../api/giftCardApi.js'

export default {
  namespaced: true,
  state: {
    settings: {
      giftCards: null
    },
    customerData: {},
    payWays: {},
    payWayInstallments: {},
    errors: [],
    countryAndCountyData: {
      country: {},
      county: {}
    },
    submittingGiftCard: false,
    initialDataSetUp: false,
    paymentResult: {}
  },
  getters: {
    isSubmittingGiftCard: (state) => state.submittingGiftCard,
    getSettings (state) {
      return state.settings
    },
    getCustomerData (state) {
      return state.customerData
    },
    getErrors (state) {
      return state.errors
    },
    getPayWays (state) {
      return state.payWays
    },
    getPayWayInstallments (state) {
      return state.payWayInstallments
    },
    getCountryAndCountyData (state) {
      return state.countryAndCountyData
    },
    hasApcopayInstallments (state) {
      return Object.hasOwn(state.payWayInstallments, 'apcopay') && state.payWayInstallments.apcopay.length > 0
    },
    hasPiraeusInstallments (state) {
      return Object.hasOwn(state.payWayInstallments, 'piraeus') && Object.keys(state.payWayInstallments.piraeus.installments).length > 1
    },
    hasEurobankInstallments (state) {
      return Object.hasOwn(state.payWayInstallments, 'eurobank') && Object.keys(state.payWayInstallments.eurobank.installments).length > 1
    },
    initialDataSetUp: (state) => state.initialDataSetUp,
    getPaymentResult: (state) => state.paymentResult,
    hasPaymentResult: (state) => JSON.stringify(state.paymentResult) !== '{}'
  },
  mutations: {
    setSubmittingGiftCard (state, submitting) {
      state.submittingGiftCard = submitting
    },
    setSettings (state, settings) {
      state.settings = settings
    },
    setPayWays (state, payWays) {
      state.payWays = payWays
    },
    setPayWayInstallments (state, payWayInstallments) {
      state.payWayInstallments = payWayInstallments
    },
    setErrors (state, errors) {
      state.errors = errors
    },
    setCustomerData (state, customerData) {
      state.customerData = customerData
    },
    setCountryAndCountyDate (state, data) {
      state.countryAndCountyData = data
    },
    initialDataSetUp (state) {
      state.initialDataSetUp = true
    },
    setPaywayResult (state, data) {
      state.paymentResult = data
    }
  },
  actions: {
    async initAll ({ commit, dispatch }, allData) {
      await dispatch('initSettings', allData.settings)
      await dispatch('initCustomerData', allData.customerData)
      await dispatch('initPayWays', allData.payWays)
      await dispatch('initPayWayInstallments', allData.payWayInstallments)
      await dispatch('initCountryAndCountyData', allData.countryAndCountyData)
      await dispatch('initErrors', allData.errors)
      commit('initialDataSetUp')
    },
    async initSettings ({ commit }, settings) {
      commit('setSettings', settings)
    },
    async initCustomerData ({ commit }, customerData) {
      commit('setCustomerData', customerData)
    },
    async initPayWays ({ commit }, payWays) {
      commit('setPayWays', payWays)
    },
    async initPayWayInstallments ({ commit }, payWayInstallments) {
      commit('setPayWayInstallments', payWayInstallments)
    },
    async initErrors ({ commit }, errors) {
      commit('setErrors', errors)
    },
    async initCountryAndCountyData ({ commit }, data) {
      commit('setCountryAndCountyDate', data)
    },
    async buyGiftCard ({ commit, state }, data) {
      commit('setSubmittingGiftCard', true)
      commit('setPaywayResult', {})
      await postGiftCard(data)
        .then(result => {
          if (!result) {
            commit('setErrors', [])
            commit('setPaywayResult', {})
            return
          }
          if (Object.hasOwn(result, 'errors')) {
            commit('setErrors', result.errors)
            commit('setPaywayResult', {})
            return
          }
          commit('setPaywayResult', result.payWayFormData)
        })
        .catch()
        .finally(() => commit('setSubmittingGiftCard', false))
    }
  }
}
